
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'


export default {
components: {
XHeader,
Group,
Cell,
Actionsheet
},
data() {
return {
showTitle: this.$route.query.showTitle,
index: this.$route.query.index,
gotoquick: this.$route.query.gotoquick,
courseChapterList: [],
currentChapter: {},
showExerciseType: false,
menuExerciseType: {
type1: "练习做题",
type2: "模拟考试"
}
};
},
created() {
this.getData();
},
methods: {
getData() {
this.showTitle = this.$route.query.showTitle;
this.index = this.$route.query.index;
this.courseChapterList = [];
this.currentChapter = {};
this.showExerciseType = false;

this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadCourseChapter",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
chaptertype: this.$route.query.type,
parentChapterId: this.$route.query.id,
showMyAnswerCount: 1
}
})
.then(response => {
if (response.status == 200) {
this.courseChapterList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
clickCourseChapter(courseChapter) {
this.currentChapter = courseChapter;
if (courseChapter.bendgrade) {

if (!courseChapter.ballowtest) {

if (process.env.NODE_ENV != "development") {
const _this = this;
this.$vux.confirm.show({
title: "请您注册",
content: "确定要提交试卷吗？",
confirmText: "激活此科目",
cancelText: "继续试用",
onConfirm() {
_this.$router.push({
path: "/ClassBuy"
});
}
});
return;
}
}

if(this.gotoquick==1){

this.$router.push({
path: "/QuickReadSubject",
query: {
chapterid: this.currentChapter.ichapterid
}
});
return;
}

if (courseChapter.itype == 0) {

this.$router.push({
path: "/SubjuectData",
query: {
chapterid: this.currentChapter.ichapterid,
showtime: this.GLOBAL.SubjectShowTime.Test
}
});
} else {

this.showExerciseType = true;
}
} else {
this.$router.push({
path: "/ChapterExercise",
query: {
id: courseChapter.ichapterid,
type: courseChapter.itype,
gotoquick:this.gotoquick,
showTitle: courseChapter.cchaptername,
index: parseInt(this.index) + 1
}
});
}
},
clickExerciseType(menuKey, menuItem) {
if (menuKey == "type1") {

this.$router.push({
path: "/SubjuectData",
query: {
chapterid: this.currentChapter.ichapterid,
showtime: this.GLOBAL.SubjectShowTime.Test
}
});
} else if (menuKey == "type2") {

/*
this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.Examination,
paperId: 4
}
});
return;
*/

this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=BuildNewPaperByChapterId",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
totalTime: 120,
fromChapterId: this.currentChapter.ichapterid
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.Examination,
paperId: (this.courseChapterList = response.data.data)
}
});
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
}
},
goBack() {
this.$router.go(-1);
},
goHome() {
if (parseInt(this.index) > 0) {
this.$router.go(-parseInt(this.index));
} else {
this.$router.replace({
path: "/"
});
}
}
},
watch: {

$route: "getData"
}
};



// WEBPACK FOOTER //
// ./src/components/ChapterExercise.vue